export const en = {
  // Navigation
  nav: {
    home: "HOME",
    aboutUs: "ABOUT US",
    ourServices: "OUR SERVICES",
    specialOffers: "SPECIAL OFFERS",
    contactUs: "CONTACT US",
    search: "SEARCH",
    searchPlaceholder: "Search services...",
    searchLoading: "Searching...",
    noResults: "No services found",
    searchResults: "Search Results",
    searchHint: "Enter at least 3 characters to search for services",
  },

  // Header
  header: {
    followSocialMedia: "FOLLOW SOCIAL MEDIA",
  },

  // Hero Section
  hero: {
    title: "Leading the future of business solutions",
    subtitle: "Innovative technology solutions for modern enterprises",
    getStarted: "Get Started",
    learnMore: "Learn More",
  },

  // Intro Section
  intro: {
    title: "About Us",
    description:
      "We are a leading company dedicated to providing innovative solutions and exceptional service to our clients worldwide.",
  },

  // Special Offers
  offers: {
    title: "Special Offers",
    description: "Exclusive deals and promotions for our valued customers",
    viewAll: "View All Offers",
    readMore: "Read More",
    noOffers: "No special offers available at the moment.",
    interestedInOffer: "Interested in This Offer?",
    offerDescription:
      "Contact us today to learn more about this special offer and how it can benefit your business.",
    loadingOffers: "Loading offers...",
    noOffersFound: "No offers found",
    offerPic: "Offer Pic",
    companyLogo: "Company Logo",
  },

  // Services
  services: {
    title: "Our Services",
    description: "Professional solutions for all your needs",
    viewAll: "View All Services",
    readMore: "Read More",
    noServices: "No services available at the moment.",
    categories: "Categories",
    allCategories: "All Categories",
    needThisService: "Need This Service?",
    serviceDescription:
      "Contact us today to learn more about this service and how it can benefit your business.",
    loadingServices: "Loading services...",
    noServicesFound: "No services found",
    noServicesInCategory: "No services available in this category.",
    servicePic: "Service Pic",
    companyLogo: "Company Logo",
  },

  // Testimonials
  testimonials: {
    title: "What Our Clients Say",
    noTestimonials: "No testimonials available at the moment.",
  },

  // Contact
  contact: {
    title: "Contact Us",
    subtitle: "Get in touch with us",
    name: "Name",
    email: "Email",
    phone: "Phone",
    subject: "Subject",
    message: "Message",
    send: "Send Message",
    address: "Address",
    getInTouch: "Get In Touch",
    followUs: "Follow Us",
    contactInfo: "Contact Information",
    contactUsNow: "Contact Us Now",
    placeholders: {
      name: "Enter your full name",
      email: "Enter your email",
      phone: "Enter your phone number",
      subject: "Enter subject",
      message: "Enter your message",
    },
  },

  // Footer
  footer: {
    allRightsReserved: "All rights reserved.",
    quickLinks: "Quick Links",
    services: "Services",
    company: "Company",
    support: "Support",
  },

  // Common
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    add: "Add",
    addNew: "Add New",
    back: "Back",
    next: "Next",
    previous: "Previous",
    close: "Close",
    submit: "Submit",
    reset: "Reset",
    view: "View",
    readMore: "Read More",
    learnMore: "Learn More",
    getStarted: "Get Started",
    contactUs: "Contact Us",
    aboutUs: "About Us",
    home: "Home",
    services: "Services",
    offers: "Offers",
    testimonials: "Testimonials",
    search: "Search",
    noImageAvailable: "No image available",
    updating: "Updating...",
  },

  // Language Switcher
  language: {
    english: "English",
    arabic: "العربية",
    switchLanguage: "Switch Language",
  },

  // Dashboard
  dashboard: {
    dashboard: "Dashboard",
    homepageSettings: "Homepage Settings",
    specialOffers: "Special Offers",
    servicesCategories: "Services Categories",
    services: "Services",
    testimonials: "Testimonials",
    linkManagement: "Link Management",
    analytics: "Analytics",
    backToTestimonials: "Back to Testimonials",
    editTestimonial: "Edit Testimonial",
    logout: "Logout",
    logoutConfirm: "Are you sure you want to logout?",
    adminUser: "Admin User",
    administrator: "Administrator",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    add: "Add",
    back: "Back",
    nameEnglish: "Name (English)",
    nameArabic: "Name (Arabic)",
    contentEnglish: "Content (English)",
    contentArabic: "Content (Arabic)",
    rating: "Rating",
    image: "Image",
    enterCustomerName: "Enter customer name",
    enterCustomerNameArabic: "Enter customer name in Arabic",
    enterTestimonialContent: "Enter testimonial content",
    enterTestimonialContentArabic: "Enter testimonial content in Arabic",
    loadingTestimonial: "Loading testimonial...",
    testimonialUpdatedSuccess: "Testimonial updated successfully!",
    errorUpdatingTestimonial: "Error updating testimonial",
    welcomeBack: "Welcome back",
    viewHomepage: "View Homepage",
    todaysVisitors: "Today's Visitors",
    totalVisitors: "Total Visitors",
    mostVisitedService: "Most Visited Service",
    mostVisitedOffer: "Most Visited Offer",
    uniqueVisitors: "Unique Visitors",
    visits: "visits",
    period: "Period",
    today: "today",
    thisWeek: "this week",
    thisMonth: "this month",
    thisYear: "this year",
    week: "this week",
    month: "this month",
    year: "this year",
    addService: "Add Service",
    createNewService: "Create a new service",
    viewDetailedAnalytics: "View detailed analytics",
    addSpecialOffer: "Add Special Offer",
    createNewOffer: "Create a new offer",
    manageTestimonials: "Manage Testimonials",
    viewAllTestimonials: "View all testimonials",
    loading: "Loading...",
    noData: "N/A",
    heresWhatsHappening: "Here's what's happening with your website today.",
    customizeHomepage: "Customize your homepage",
    createAndTrackCustomLinks: "Create and track custom links",
    generalSystemSettings: "General system settings",
    quickActions: "Quick Actions",
    clickToViewDetails: "Click to view details",
  },

  // Homepage Settings
  homepageSettings: {
    title: "Homepage Settings",
    subtitle: "Customize your homepage content and appearance",
    previewHomepage: "Preview Homepage",
    saveChanges: "Save Changes",
    saving: "Saving...",
    loadingSettings: "Loading settings...",
    authenticationRequired: "Authentication Required",
    pleaseLoginToAccess: "Please log in to access homepage settings.",
    goToLogin: "Go to Login",
    logIn: "Log In",
    pleaseLoginToSave: "Please log in to save settings.",
    sessionExpired: "Session expired",
    logoAndBranding: "Logo & Branding",
    uploadAndManageBrandAssets: "Upload and manage your brand assets",
    socialMedia: "Social Media",
    manageYourSocialMediaLinks: "Manage your social media links",
    contactInfo: "Contact Info",
    manageYourContactInformation: "Manage your contact information",
    aboutUs: "About Us",
    manageYourAboutUsContent: "Manage your about us content",
    heroSlider: "Hero Slider",
    manageYourHeroSlider: "Manage your hero slider slides",
    headTags: "Head Tags",
    manageHeadTags: "Manage meta tags, Open Graph, and other head elements",
    addSlide: "Add Slide",
    removeSlide: "Remove Slide",
    slideImage: "Slide Image",
    slideTitle: "Slide Title",
    slideTitleArabic: "Slide Title (Arabic)",
    slideDescription: "Slide Description",
    slideDescriptionArabic: "Slide Description (Arabic)",
    buttonText: "Button Text",
    buttonTextArabic: "Button Text (Arabic)",
    buttonLink: "Button Link",
    companyName: "Company Name",
    companyNameArabic: "Company Name (Arabic)",
    tagline: "Tagline",
    taglineArabic: "Tagline (Arabic)",
    heroBackground: "Hero Background",
    facebook: "Facebook",
    twitter: "Twitter",
    linkedin: "LinkedIn",
    instagram: "Instagram",
    youtube: "YouTube",
    tiktok: "TikTok",
    snapchat: "Snapchat",
    pinterest: "Pinterest",
    telegram: "Telegram",
    whatsapp: "WhatsApp",
    discord: "Discord",
    phone: "Phone",
    email: "Email",
    address: "Address",
    addressArabic: "Address (Arabic)",
    addressLink: "Address Link",
    whatsappDefaultMessage: "WhatsApp Default Message",
    aboutContent: "About Content",
    aboutContentArabic: "About Content (Arabic)",
    footerParagraph: "Footer Paragraph",
    footerParagraphArabic: "Footer Paragraph (Arabic)",
    uploadImage: "Upload Image",
    removeImage: "Remove Image",
    enterCompanyName: "Enter company name",
    enterCompanyNameArabic: "Enter company name in Arabic",
    enterTagline: "Enter company tagline",
    enterTaglineArabic: "Enter company tagline in Arabic",
    enterPhoneNumber: "Enter phone number",
    enterEmailAddress: "Enter email address",
    enterAddress: "Enter address",
    enterAddressArabic: "Enter address in Arabic",
    enterWhatsAppDefaultMessage: "Enter default message for WhatsApp",
    enterAboutContent: "Enter about us content",
    enterAboutContentArabic: "Enter about us content in Arabic",
    enterFooterParagraph: "Enter footer paragraph",
    enterFooterParagraphArabic: "Enter footer paragraph in Arabic",
    enterSocialMediaUrl: "Enter social media URL",
    settingsSavedSuccessfully: "Settings saved successfully!",
    errorSavingSettings: "Error saving settings",
    placeholderEnterCompanyName: "Enter company name",
    placeholderEnterCompanyNameArabic: "أدخل اسم الشركة",
    placeholderEnterCompanyTagline: "Enter company tagline",
    placeholderEnterCompanyTaglineArabic: "أدخل شعار الشركة",
    placeholderEnterEmailAddress: "Enter email address",
    placeholderEnterPhoneNumber: "Enter phone number",
    placeholderEnterFooterText:
      "Enter footer text (e.g., copyright notice, company description)",
    placeholderEnterFooterTextArabic:
      "أدخل نص التذييل (مثل إشعار حقوق النشر، وصف الشركة)",
    placeholderEnterFullAddress: "Enter full address",
    placeholderEnterFullAddressArabic: "أدخل العنوان الكامل",
    placeholderEnterAboutUsTitle: "Enter about us title",
    placeholderEnterAboutUsTitleArabic: "أدخل عنوان من نحن",
    placeholderEnterAboutUsDescription: "Enter about us description",
    placeholderEnterAboutUsDescriptionArabic: "أدخل وصف من نحن",
    addImage: "Add Image",
  },

  // Special Offers Dashboard
  specialOffersDashboard: {
    loadingOffers: "Loading special offers...",
    authenticationRequired: "Authentication Required",
    pleaseLoginToManage: "Please log in to manage special offers.",
    goToLogin: "Go to Login",
    manageYourOffers: "Manage your special offers and promotions",
    addFirstOffer: "Add First Offer",
    addFirstOfferDescription: "Add your first special offer to get started",
    image: "Image",
    title: "Title",
    contentPreview: "Content Preview",
    status: "Status",
    created: "Created",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    editOffer: "Edit Offer",
    deleteOffer: "Delete Offer",
    deleteConfirmMessage: "Are you sure you want to delete this special offer?",
    offerDeletedSuccessfully: "Special offer deleted successfully!",
    errorDeletingOffer: "Error deleting special offer.",
    offerActivatedSuccessfully: "Offer activated successfully!",
    offerDeactivatedSuccessfully: "Offer deactivated successfully!",
    errorUpdatingOffer: "Error updating offer status",
  },

  // Add/Edit Special Offer Pages
  addEditOffer: {
    authenticationRequired: "Authentication Required",
    pleaseLoginToCreate: "Please log in to create special offers.",
    pleaseLoginToEdit: "Please log in to edit special offers.",
    goToLogin: "Go to Login",
    backToOffers: "Back to Offers",
    addNewSpecialOffer: "Add New Special Offer",
    editSpecialOffer: "Edit Special Offer",
    createNewOffer: "Create a new special offer or promotion",
    updateOfferDetails: "Update your special offer details",
    loadingOffer: "Loading offer...",
    offerNotFound: "Offer Not Found",
    offerNotFoundMessage: "The special offer you're looking for doesn't exist.",
    offerTitleEnglish: "Offer Title (English)",
    offerTitleArabic: "Offer Title (Arabic)",
    offerImage: "Offer Image",
    offerContentEnglish: "Offer Content (English)",
    offerContentArabic: "Offer Content (Arabic)",
    activeOffer: "Active Offer",
    keywords: "Keywords",
    enterKeywords: "Enter keywords (comma-separated)",
    keywordsHint: "Separate keywords with commas (e.g., service, maintenance, repair)",
    metaTitle: "SEO Meta Title",
    enterMetaTitle: "Enter SEO meta title (optional)",
    metaTitleHint: "If provided, this will be used as the page title instead of the offer title",
    metaDescription: "SEO Meta Description",
    enterMetaDescription: "Enter SEO meta description (optional)",
    metaDescriptionHint: "If provided, this will be used as the page description instead of the general one",
    enterOfferTitle: "Enter offer title",
    enterOfferTitleArabic: "أدخل عنوان العرض",
    enterOfferDetails: "Enter offer details, terms, and conditions...",
    enterOfferDetailsArabic: "أدخل تفاصيل العرض والشروط والأحكام...",
    cancel: "Cancel",
    createOffer: "Create Offer",
    updateOffer: "Update Offer",
    creating: "Creating...",
    updating: "Updating...",
    pleaseLoginToSave: "Please log in to save special offers.",
    pleaseEnterTitle: "Please enter a title for the offer.",
    pleaseEnterContent: "Please enter content for the offer.",
    offerCreatedSuccessfully: "Special offer created successfully!",
    offerUpdatedSuccessfully: "Special offer updated successfully!",
    errorCreatingOffer: "Error creating special offer.",
    errorUpdatingOffer: "Error updating special offer.",
    ctaSection: "Call-to-Action (CTA) Section",
    ctaTitle: "CTA Title",
    ctaTitleAr: "CTA Title (Arabic)",
    ctaDescription: "CTA Description",
    ctaDescriptionAr: "CTA Description (Arabic)",
    ctaButton1Text: "CTA Button 1 Text",
    ctaButton1TextAr: "CTA Button 1 Text (Arabic)",
    ctaButton2Text: "CTA Button 2 Text",
    ctaButton2TextAr: "CTA Button 2 Text (Arabic)",
    enterCtaTitle: "Enter CTA title",
    enterCtaTitleAr: "أدخل عنوان CTA",
    enterCtaDescription: "Enter CTA description",
    enterCtaDescriptionAr: "أدخل وصف CTA",
    enterCtaButton1Text: "Enter button 1 text (e.g., Contact Us Now)",
    enterCtaButton1TextAr: "أدخل نص الزر الأول",
    enterCtaButton2Text: "Enter button 2 text (e.g., View All Offers)",
    enterCtaButton2TextAr: "أدخل نص الزر الثاني",
    ctaButton1Link: "CTA Button 1 Link",
    ctaButton2Link: "CTA Button 2 Link",
    enterCtaButton1Link: "Enter button 1 link (e.g., /#contact or https://example.com)",
    enterCtaButton2Link: "Enter button 2 link (e.g., /offers or https://example.com)",
    ctaButtonLinkHint: "Enter a relative path (e.g., /#contact) or full URL (e.g., https://example.com). Leave empty to use default behavior.",
  },

  // Services Dashboard
  servicesDashboard: {
    loading: "Loading...",
    authenticationRequired: "Authentication Required",
    pleaseLoginToManage: "Please log in to manage services categories.",
    goToLogin: "Go to Login",
    servicesCategories: "Services Categories",
    manageServiceCategories: "Manage service categories",
    addNewCategory: "Add New Category",
    title: "Title",
    status: "Status",
    created: "Created",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    editCategory: "Edit Category",
    deleteCategory: "Delete Category",
    deleteConfirmMessage: "Are you sure you want to delete this category?",
    categoryDeletedSuccessfully: "Category deleted successfully!",
    errorDeletingCategory: "Error deleting category.",
    noCategoriesFound: "No categories found",
    backToCategories: "Back to Categories",
  },

  // Add/Edit Category Pages
  addEditCategory: {
    authenticationRequired: "Authentication Required",
    pleaseLoginToCreate: "Please log in to create service categories.",
    pleaseLoginToEdit: "Please log in to edit service categories.",
    addNewCategory: "Add New Category",
    editCategory: "Edit Category",
    createNewCategory: "Create a new service category",
    editExistingCategory: "Edit existing service category",
    categoryTitleEnglish: "Category Title (English) *",
    categoryTitleArabic: "Category Title (Arabic)",
    enterCategoryTitle: "Enter category title",
    enterCategoryTitleAr: "أدخل عنوان الفئة",
    categoryImage: "Category Image",
    categoryDescriptionEnglish: "Category Description (English)",
    categoryDescriptionArabic: "Category Description (Arabic)",
    enterCategoryDescription: "Enter category description...",
    enterCategoryDescriptionArabic: "أدخل وصف الفئة...",
    activeCategory: "Active Category",
    pleaseEnterTitle: "Please enter a title for the category.",
    categoryCreatedSuccessfully: "Category created successfully!",
    categoryUpdatedSuccessfully: "Category updated successfully!",
    errorCreatingCategory: "Error creating category.",
    errorUpdatingCategory: "Error updating category.",
    pleaseLoginToSave: "Please log in to save categories.",
    cancel: "Cancel",
    save: "Save",
    saving: "Saving...",
    categoryNotFound: "Category Not Found",
    categoryNotFoundMessage: "The category you're looking for doesn't exist.",
  },

  // Add/Edit Service Pages
  addEditService: {
    authenticationRequired: "Authentication Required",
    pleaseLoginToCreate: "Please log in to create services.",
    pleaseLoginToEdit: "Please log in to edit services.",
    goToLogin: "Go to Login",
    backToServices: "Back to Services",
    addNewService: "Add New Service",
    editService: "Edit Service",
    createNewService: "Create a new service",
    updateServiceDetails: "Update your service details",
    loadingService: "Loading service...",
    serviceNotFound: "Service Not Found",
    serviceNotFoundMessage: "The service you're looking for doesn't exist.",
    serviceTitleEnglish: "Service Title (English)",
    serviceTitleArabic: "Service Title (Arabic)",
    serviceImage: "Service Image",
    multipleImages: "Additional Images",
    serviceContentEnglish: "Service Content (English)",
    serviceContentArabic: "Service Content (Arabic)",
    serviceCategory: "Service Category",
    selectCategory: "Select Category",
    activeService: "Active Service",
    keywords: "Keywords",
    enterKeywords: "Enter keywords (comma-separated)",
    keywordsHint: "Separate keywords with commas (e.g., service, maintenance, repair)",
    metaTitle: "SEO Meta Title",
    enterMetaTitle: "Enter SEO meta title (optional)",
    metaTitleHint: "If provided, this will be used as the page title instead of the service title",
    metaDescription: "SEO Meta Description",
    enterMetaDescription: "Enter SEO meta description (optional)",
    metaDescriptionHint: "If provided, this will be used as the page description instead of the general one",
    enterServiceTitle: "Enter service title",
    enterServiceTitleArabic: "أدخل عنوان الخدمة",
    enterServiceDetails: "Enter service details, features, and benefits...",
    enterServiceDetailsArabic: "أدخل تفاصيل الخدمة والميزات والفوائد...",
    cancel: "Cancel",
    createService: "Create Service",
    updateService: "Update Service",
    creating: "Creating...",
    updating: "Updating...",
    pleaseLoginToSave: "Please log in to save services.",
    pleaseEnterTitle: "Please enter a title for the service.",
    pleaseEnterContent: "Please enter content for the service.",
    pleaseSelectCategory: "Please select a category for the service.",
    serviceCreatedSuccessfully: "Service created successfully!",
    serviceUpdatedSuccessfully: "Service updated successfully!",
    errorCreatingService: "Error creating service.",
    errorUpdatingService: "Error updating service.",
    ctaSection: "Call-to-Action (CTA) Section",
    ctaTitle: "CTA Title",
    ctaTitleAr: "CTA Title (Arabic)",
    ctaDescription: "CTA Description",
    ctaDescriptionAr: "CTA Description (Arabic)",
    ctaButton1Text: "CTA Button 1 Text",
    ctaButton1TextAr: "CTA Button 1 Text (Arabic)",
    ctaButton2Text: "CTA Button 2 Text",
    ctaButton2TextAr: "CTA Button 2 Text (Arabic)",
    enterCtaTitle: "Enter CTA title",
    enterCtaTitleAr: "أدخل عنوان CTA",
    enterCtaDescription: "Enter CTA description",
    enterCtaDescriptionAr: "أدخل وصف CTA",
    enterCtaButton1Text: "Enter button 1 text (e.g., Contact Us Now)",
    enterCtaButton1TextAr: "أدخل نص الزر الأول",
    enterCtaButton2Text: "Enter button 2 text (e.g., View All Services)",
    enterCtaButton2TextAr: "أدخل نص الزر الثاني",
    ctaButton1Link: "CTA Button 1 Link",
    ctaButton2Link: "CTA Button 2 Link",
    enterCtaButton1Link: "Enter button 1 link (e.g., /#contact or https://example.com)",
    enterCtaButton2Link: "Enter button 2 link (e.g., /offers or https://example.com)",
    ctaButtonLinkHint: "Enter a relative path (e.g., /#contact) or full URL (e.g., https://example.com). Leave empty to use default behavior.",
  },

  // Services Main Dashboard
  servicesMainDashboard: {
    loading: "Loading...",
    authenticationRequired: "Authentication Required",
    pleaseLoginToManage: "Please log in to manage services.",
    goToLogin: "Go to Login",
    services: "Services",
    manageYourServices: "Manage your services",
    addNewService: "Add New Service",
    image: "Image",
    title: "Title",
    category: "Category",
    contentPreview: "Content Preview",
    status: "Status",
    created: "Created",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    noCategory: "No Category",
    editService: "Edit Service",
    deleteService: "Delete Service",
    deleteConfirmMessage: "Are you sure you want to delete this service?",
    serviceDeletedSuccessfully: "Service deleted successfully!",
    errorDeletingService: "Error deleting service.",
    serviceActivatedSuccessfully: "Service activated successfully!",
    serviceDeactivatedSuccessfully: "Service deactivated successfully!",
    errorUpdatingService: "Error updating service status",
  },

  // Testimonials Dashboard
  testimonialsDashboard: {
    loading: "Loading...",
    authenticationRequired: "Authentication Required",
    pleaseLoginToManage: "Please log in to manage testimonials.",
    goToLogin: "Go to Login",
    testimonials: "Testimonials",
    manageYourTestimonials: "Manage your testimonials",
    addNewTestimonial: "Add New Testimonial",
    image: "Image",
    name: "Name",
    rating: "Rating",
    content: "Content",
    created: "Created",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    editTestimonial: "Edit Testimonial",
    deleteTestimonial: "Delete Testimonial",
    deleteConfirmMessage: "Are you sure you want to delete this testimonial?",
    testimonialDeletedSuccessfully: "Testimonial deleted successfully!",
    errorDeletingTestimonial: "Error deleting testimonial.",
    noTestimonialsYet: "No Testimonials Yet",
    getStartedByCreating: "Get started by creating your first testimonial.",
    addFirstTestimonial: "Add First Testimonial",
  },

  // Add/Edit Testimonial Pages
  addEditTestimonial: {
    backToTestimonials: "Back to Testimonials",
    addNewTestimonial: "Add New Testimonial",
    editTestimonial: "Edit Testimonial",
    createNewTestimonial: "Create a new testimonial",
    updateTestimonialDetails: "Update your testimonial details",
    loadingTestimonial: "Loading testimonial...",
    testimonialNotFound: "Testimonial Not Found",
    testimonialNotFoundMessage:
      "The testimonial you're looking for doesn't exist.",
    customerNameEnglish: "Customer Name (English)",
    customerNameArabic: "Customer Name (Arabic)",
    testimonialContentEnglish: "Testimonial Content (English)",
    testimonialContentArabic: "Testimonial Content (Arabic)",
    rating: "Rating",
    testimonialImage: "Testimonial Image",
    enterCustomerName: "Enter customer name",
    enterCustomerNameArabic: "أدخل اسم العميل",
    enterTestimonialContent: "Enter testimonial content...",
    enterTestimonialContentArabic: "أدخل محتوى الشهادة...",
    cancel: "Cancel",
    createTestimonial: "Create Testimonial",
    updateTestimonial: "Update Testimonial",
    creating: "Creating...",
    updating: "Updating...",
    pleaseEnterName: "Please enter a customer name.",
    pleaseEnterContent: "Please enter testimonial content.",
    testimonialCreatedSuccessfully: "Testimonial created successfully!",
    testimonialUpdatedSuccessfully: "Testimonial updated successfully!",
    errorCreatingTestimonial: "Error creating testimonial.",
    errorUpdatingTestimonial: "Error updating testimonial.",
  },

  // Links Dashboard
  linksDashboard: {
    loading: "Loading links...",
    linkManagement: "Link Management",
    createAndTrackLinks:
      "Create and track custom links for your services and offers",
    createNewLink: "Create New Link",
    title: "Title",
    description: "Description",
    type: "Type",
    target: "Target",
    customUrl: "Custom URL",
    shortUrl: "Short URL",
    clicks: "Clicks",
    status: "Status",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    service: "Service",
    offer: "Offer",
    custom: "Custom",
    editLink: "Edit Link",
    deleteLink: "Delete Link",
    copyLink: "Copy Link",
    linkCopied: "Link copied to clipboard!",
    deleteConfirmMessage: "Are you sure you want to delete this link?",
    linkDeletedSuccessfully: "Link deleted successfully!",
    errorDeletingLink: "Error deleting link.",
    linkCreatedSuccessfully: "Link created successfully!",
    linkUpdatedSuccessfully: "Link updated successfully!",
    errorCreatingLink: "Error creating link.",
    errorUpdatingLink: "Error updating link.",
    enterLinkTitle: "Enter link title",
    enterLinkDescription: "Enter link description",
    enterCustomUrl: "Enter custom URL",
    pleaseEnterTitle: "Please enter a title.",
    pleaseSelectType: "Please select a type.",
    pleaseSelectTarget: "Please select a target.",
    noLinksYet: "No Links Yet",
    getStartedByCreating: "Get started by creating your first link.",
    addFirstLink: "Add First Link",
    totalLinks: "Total Links",
    activeLinks: "Active Links",
    totalClicks: "Total Clicks",
    created: "Created",
    viewQRCode: "View QR Code",
    createNewLink: "Create New Link",
    title: "Title",
    description: "Description",
    linkType: "Link Type",
    service: "Service",
    active: "Active",
    selectService: "Select a service",
    selectOffer: "Select an offer",
    createLink: "Create Link",
    cancel: "Cancel",
    enterLinkTitle: "Enter link title",
    enterLinkDescription: "Enter link description",
  },

  // Analytics Dashboard
  analyticsDashboard: {
    loading: "Loading analytics data...",
    backToDashboard: "Back to Dashboard",
    analyticsDashboard: "Analytics Dashboard",
    detailedVisitorAnalytics: "Detailed visitor analytics and insights",
    refresh: "Refresh",
    refreshing: "Refreshing...",
    period: "Period",
    today: "Today",
    thisWeek: "This Week",
    thisMonth: "This Month",
    thisYear: "This Year",
    custom: "Custom",
    from: "From",
    to: "To",
    apply: "Apply",
    overview: "Overview",
    totalVisitors: "Total Visitors",
    uniqueVisitors: "Unique Visitors",
    uniquePages: "Unique Pages",
    totalPageViews: "Total Page Views",
    averageSessionDuration: "Average Session Duration",
    bounceRate: "Bounce Rate",
    mostVisitedPages: "Most Visited Pages",
    page: "Page",
    visits: "Visits",
    percentage: "Percentage",
    noDataFound: "No data found",
    serviceVisits: "Service Visits",
    noServiceVisitsFound: "No service visits found",
    offerVisits: "Offer Visits",
    noOfferVisitsFound: "No offer visits found",
    visitors: "visitors",
    minutes: "minutes",
    percent: "%",
    type: "Type",
    service: "Service",
    offer: "Offer",
  },

  // Visitor Details
  visitorDetails: {
    loading: "Loading visitor data...",
    error: "Error loading data",
    retry: "Retry",
    backToDashboard: "Back to Dashboard",
    visitorDetails: "Visitor Details",
    visitorAnalytics: "Visitor analytics and details",
    refresh: "Refresh",
    period: "Period",
    today: "Today",
    thisWeek: "This Week",
    thisMonth: "This Month",
    allTime: "All Time",
    totalVisitors: "Total Visitors",
    visitTime: "Visit Time",
    page: "Page",
    pageType: "Page Type",
    ipAddress: "IP Address",
    country: "Country",
    browser: "Browser",
    device: "Device",
    referrer: "Referrer",
    direct: "Direct",
    noVisitorsFound: "No visitors found",
    previous: "Previous",
    next: "Next",
    page: "Page",
    of: "of",
    localhost: "Localhost",
    unknownLocation: "Unknown Location",
    unknown: "Unknown",
    local: "Local",
    unknownCountry: "Unknown Country",
    mobile: "Mobile",
    tablet: "Tablet",
    desktop: "Desktop",
    other: "Other",
  },
};
